module.exports = __webpack_public_path__ + "img/ic_company_info@2x.24806424.png";